import { forwardRef } from 'react';
import './Button.css';

const Button = forwardRef(({
  children,
  variant = 'neutral',
  size = 'md',
  loading = false,
  startIcon,
  endIcon,
  className = '',
  disabled,
  type = 'button',
  ...props
}, ref) => {
  const isDisabled = disabled || loading;

  return (
    <button
      ref={ref}
      type={type}
      className={`rds-button rds-focusable rds-button--${variant} rds-button--${size} ${className}`.trim()}
      disabled={isDisabled}
      aria-busy={loading || undefined}
      data-loading={loading || undefined}
      {...props}
    >
      {loading && <span className="rds-button__spinner" aria-hidden="true" />}
      {!loading && startIcon && <span className="rds-button__icon" aria-hidden="true">{startIcon}</span>}
      <span className="rds-button__label">{children}</span>
      {!loading && endIcon && <span className="rds-button__icon" aria-hidden="true">{endIcon}</span>}
    </button>
  );
});

Button.displayName = 'Button';

export default Button;
